import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { Link, withRouter } from 'react-router';
import clone from 'clone';
import {
  Grid,
  Header,
  Icon,
  Loader,
  Popup,
  Select,
  Table,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import SearchFilter from '../../../../components/SearchFilter';
import SortButton from '../../../../components/SortButton';
import PageNav from '../../../../components/PageNav';
import { decodeSearch, encodeSearch } from '../../../../utils/url';
import isNumber from '../../../../utils/numbers/isNumber';
import config from '../../../../../config';

moment.locale('en-gb');

class ComponentList extends Component {
  static propTypes = {
    params: PropTypes.shape({
      himsSettingID: PropTypes.string,
    }),
    id: PropTypes.string,
    project: PropTypes.object,
    himsSettings: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      himsDevelopmentCode: PropTypes.string,
    })),
    data: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      query: PropTypes.object,
    }),
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const count = props.data.length || 0;
    const currentPage = parseInt(query.page, 10) || 1;
    const data = props.data || [];
    const loading = props.loading;
    const himsSettingID = props.params.himsSettingID || '';
    return {
      count,
      currentPage,
      loading,
      himsSettingID,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    const state = ComponentList.getPropsToState(props);
    const limit = 20;
    const currentPage = parseInt(query.page, 10) || 1;
    const offset = (currentPage - 1) * limit;
    this.state = {
      data: [],
      count: 0,
      loading: true,
      offset,
      search,
      limit,
      currentPage,
      ...state,
    };
  }
  componentDidMount() {
    const { query } = this.props.location;
    if (!isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    this.replaceQuery(query);
  }
  componentWillReceiveProps(nextProps) {
    const state = ComponentList.getPropsToState(nextProps);
    const query = decodeSearch(nextProps.location.search);
    this.getDataByPage(query.page || 1);
    this.setState({ ...state });
  }
  getDataByPage = (page) => {
    const { oriData, limit, search } = this.state;
    let data = oriData || [];
    if (search) {
      data = data.filter(d => d.pembangunan_id.includes(search));
    }
    data = data.slice((page - 1) * limit, page * limit);
    this.setState({ data });
  }
  handleChangePage = (page) => {
    const { limit } = this.state;
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    const offset = (currentPage - 1) * limit;
    query.page = currentPage;
    this.setState({ currentPage, offset });
    this.replaceQuery(query);
  }
  handleFilterOnChange = (value) => {
    this.setState({ search: value }, () => {
      this.getDataByPage(1);
    });
  }
  handleClearFilter = (...queryArray) => {
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      delete query[filter];
      if (filter === 'search') {
        this.setState({
          search: '',
        });
      }
    });
    this.replaceQuery(query);
  }
  replaceQuery(query) {
    const { store } = this.context;
    const { himsSettingID } = this.state;
    this.getDataByPage(query.page);
    store.dispatch(replace(`/projects/${this.props.id}/units/hims/${himsSettingID ? `${himsSettingID}/` : ''}?${encodeSearch(query)}`));
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleOnHimsSettingChange = (e, d) => {
    this.setState({ himsSettingID: d.value }, () => {
      this.replaceQuery(1);
    });
  }
  renderMobileCell = (value) => {
    const url = `/projects/${this.props.id}/units/hims/${this.state.himsSettingID}/components/${value.pembangunan_id}/`;
    return (
      <Table.Cell className="computer-hide">
        <Grid
          columns="equal"
          verticalAlign="middle"
        >
          <Grid.Column>
            <Link to={url}>
              {value.pembangunan_id}
            </Link>
            <br />
            {value.jenis_rumah}
            <br />
            RM {value.harga_minimum.toFixed(2)} - {value.harga_maksimum.toFixed(2)}
          </Grid.Column>
          <Link to={url}>
            <Icon name="chevron right" style={{ float: 'right', marginTop: '1em' }} />
          </Link>
        </Grid>
      </Table.Cell>
    );
  };
  renderBody() {
    const { data } = this.state;
    const { loading } = this.props;
    return (
      !loading && data.length > 0 ?
        data.map((value, index) => (
          <Table.Row key={index}>
            {this.renderMobileCell(value)}
            <Table.Cell className="mobile-hide">
              <Popup
                trigger={
                  <Link to={`/projects/${this.props.id}/units/hims/${this.state.himsSettingID}/components/${value.pembangunan_id}/`}>
                    {value.pembangunan_id}
                  </Link>
                }
                content="Click to see units"
                size="mini"
                position="right center"
              />
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.jenis_rumah}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.bil_tingkat}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.bil_unit}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.harga_minimum.toFixed(2)}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.harga_maksimum.toFixed(2)}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.luas_tanah.toFixed(2)}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.luas_binaan.toFixed(2)}
            </Table.Cell>
          </Table.Row>
        ))
      :
        <Table.Row>
          <Table.Cell colSpan="100%" textAlign="center">
            {
              loading ?
                <Loader active inline="centered">Loading</Loader>
              : <p>No components found.</p>
            }
          </Table.Cell>
        </Table.Row>
    );
  }
  renderTable() {
    const { loading, id, isMobile, isTablet, himsSettings } = this.props;
    const { himsSettingID } = this.state;
    const exportItems = [
      {
        text: 'Excel',
        icon: 'download',
        href: `${config.get('bookApiURL')}/projects/${id}/hims/${this.state.himsSettingID}/components/export/`,
      },
    ];
    return (
      <Table
        celled
        unstackable
        structured
      >
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="100%">
              <Grid columns={1} verticalAlign="middle">
                <Grid.Column>
                  <SearchFilter
                    inTable
                    searchWidth={isMobile ? 16 : (isTablet ? 8 : 7)}
                    leftNavWidth={(isMobile || isTablet) ? 16 : 4}
                    rightNavWidth={isMobile ? 16 : (isTablet ? 8 : 5)}
                    isLoading={loading}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    search={this.state.search}
                    advanceFilter={this.state.advanceFilter}
                    leftNav={(
                      <Header style={{ marginLeft: '0.5em', marginTop: '0.25em', marginBottom: '0.5em' }}>
                        List of Components
                      </Header>
                    )}
                    rightNav={(
                      <div>
                        <Select
                          disabled={himsSettings.length === 0 || loading}
                          loading={loading}
                          onChange={this.handleOnHimsSettingChange}
                          value={himsSettingID}
                          placeholder="Select Project Code"
                          options={himsSettings.map(hs => ({
                            value: hs.id,
                            text: `Project Code (${hs.himsDevelopmentCode})`,
                          }))}
                        />
                        <SortButton
                          loading={loading}
                          icon="download"
                          items={exportItems}
                        />
                      </div>
                    )}
                  />
                </Grid.Column>
              </Grid>
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="mobile-hide">Pembangunan ID</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Jenis Rumah</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Bil Tingkat</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Bil Unit</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Harga Minimum</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Harga Maksimum</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Luas Tanah</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Luas Binaan</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.renderBody()}
        </Table.Body>
      </Table>
    );
  }
  render() {
    const { count, limit, offset, currentPage } = this.state;
    const { loading } = this.props;
    return (
      <Grid>
        <Grid.Column width={16} textAlign="center">
          {this.renderTable()}
          <Grid.Column style={{ marginTop: '3em' }} textAlign="center">
            <PageNav
              currentPage={currentPage}
              count={count}
              limit={limit}
              offset={offset}
              dataSize={this.state.data.length}
              loading={loading}
              onChange={this.handleChangePage}
            />
          </Grid.Column>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withRouter(ComponentList);



// WEBPACK FOOTER //
// ./src/containers/Project/Units/HIMSUnitSync/ComponentList.jsx